<div class="mb-32">
  <span class="title title--big">Настройки системы</span>
</div>

<div class="padding-24 pos-r" *ngIf="loading">
  <app-loader></app-loader>
</div>

<div *ngIf="!loading && appSettingsError">
  <app-message [type]="'error'">
    <div message-content>{{ appSettingsError }}</div>
  </app-message>
</div>

<app-tabs [justifyContent]="'center'" [tabActive]="tabActiveManual" (tabChange)="onChangeSettingsType($event)" *ngIf="!loading && appSettings">
  <app-tab [title]="'Распределение заявок'" [id]="'ticketsSettings'">
    <app-tickets-settings [settings]="appSettings"></app-tickets-settings>
  </app-tab>
  <app-tab [title]="'Синхронизация данных'" [id]="'dataSyncSettings'">
    <app-data-sync-settings [settings]="appSettings"></app-data-sync-settings>
  </app-tab>
  <app-tab [title]="'Другие настройки'" [id]="'generalSettings'">
    <app-general-settings [settings]="appSettings"></app-general-settings>
  </app-tab>
</app-tabs>
